import { render, staticRenderFns } from "./NewAddressSection.vue?vue&type=template&id=2cc6c746&"
import script from "./NewAddressSection.vue?vue&type=script&lang=js&"
export * from "./NewAddressSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports